import { Link } from 'react-router-dom';

export default function SeoGuidesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              Shopping Guides &amp; Resources
            </h2>
            <p className="text-sm text-foreground-500 max-w-md">
              Everything you need to know about using Kakobuy Spreadsheet effectively and finding the best products.
            </p>
          </div>
          <Link
            to="/kakobuy-spreadsheet-guide"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
          >
            View All Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <Link
            to="/kakobuy-spreadsheet-guide"
            className="group block rounded-2xl bg-background-100 overflow-hidden hover:bg-background-200/80 transition-all"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimal%20workspace%20desk%20with%20laptop%20showing%20spreadsheet%20data%20and%20product%20images%20organized%2C%20warm%20natural%20light%2C%20modern%20office%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20editorial%20photography%2C%20soft%20shadows%2C%20organized%20layout%2C%208k%20detail&width=800&height=500&seq=guide-card-01-spreadsheet&orientation=landscape"
                alt="Kakobuy Spreadsheet Complete Guide 2026"
                title="Kakobuy Spreadsheet Guide"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                Pillar Guide
              </span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                Kakobuy Spreadsheet Ultimate Guide 2026
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                Complete walkthrough on how to use Kakobuy Spreadsheet to find, compare, and organize the best shopping finds.
              </p>
            </div>
          </Link>

          <div className="group block rounded-2xl bg-background-100 overflow-hidden">
            <div className="p-5">
              <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
                Comparison
              </span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                Spreadsheet Comparison Hub
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                Compare Kakobuy with CSSBuy, Superbuy, and Oopbuy spreadsheets to find the best shopping platform.
              </p>
              <div className="flex flex-wrap gap-2">
                <Link
                  to="/kakobuy-spreadsheet-guide"
                  className="inline-flex items-center px-3 py-1.5 rounded-full bg-background-200/70 text-xs text-foreground-600 hover:bg-background-300 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  Kakobuy
                  <i className="ri-arrow-right-line ml-1 text-[10px]"></i>
                </Link>
                <Link
                  to="/cssbuy-spreadsheet-guide"
                  className="inline-flex items-center px-3 py-1.5 rounded-full bg-background-200/70 text-xs text-foreground-600 hover:bg-background-300 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  CSSBuy
                  <i className="ri-arrow-right-line ml-1 text-[10px]"></i>
                </Link>
                <Link
                  to="/superbuy-spreadsheet-guide"
                  className="inline-flex items-center px-3 py-1.5 rounded-full bg-background-200/70 text-xs text-foreground-600 hover:bg-background-300 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  Superbuy
                  <i className="ri-arrow-right-line ml-1 text-[10px]"></i>
                </Link>
                <Link
                  to="/oopbuy-spreadsheet-guide"
                  className="inline-flex items-center px-3 py-1.5 rounded-full bg-background-200/70 text-xs text-foreground-600 hover:bg-background-300 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  Oopbuy
                  <i className="ri-arrow-right-line ml-1 text-[10px]"></i>
                </Link>
              </div>
            </div>
            <div className="aspect-[16/9] overflow-hidden mt-2">
              <img
                src="https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20layout%20showing%20two%20organized%20product%20displays%20side%20by%20side%2C%20minimal%20clean%20design%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20soft%20lighting%2C%20modern%20UI%20aesthetic%2C%20product%20grid%20comparison%2C%208k%20detail&width=800&height=450&seq=guide-card-02-compare&orientation=landscape"
                alt="Spreadsheet comparison between platforms"
                title="Spreadsheet Platform Comparison"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="group block rounded-2xl bg-background-100 overflow-hidden">
            <div className="p-5">
              <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                Safety
              </span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                Shopping Safety Guide
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                Learn how to verify products, check quality, and shop securely using the Kakobuy Spreadsheet system.
              </p>
            </div>
            <div className="aspect-[16/9] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimal%20security%20concept%20with%20shield%20icon%20and%20verified%20badge%20on%20cream%20background%2C%20soft%20warm%20lighting%2C%20trust%20and%20safety%20aesthetic%2C%20editorial%20photography%2C%20modern%20design%2C%20reassuring%20visuals%2C%20pastel%20tones%2C%208k%20detail&width=800&height=450&seq=guide-card-03-safety&orientation=landscape"
                alt="Kakobuy Spreadsheet Shopping Safety Guide"
                title="Shopping Safety Guide"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}